/* Product gallery: two-layer cross-fade, preloading, thumbnails, chevrons,
   arrow keys, touch swipe, counter, magnifier zoom on hover devices,
   full-screen snap viewer on touch ones. */
(function () {
  var ZOOM = 2;
  var canHover = window.matchMedia('(hover: hover)').matches;

  function initGallery(gallery) {
    if (gallery.bqGalleryInit) return;
    gallery.bqGalleryInit = true;

    var stage = gallery.querySelector('[data-bq-gallery-stage]');
    var baseImage = gallery.querySelector('[data-bq-gallery-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bq-gallery-thumb]'));
    if (!stage || !baseImage) return;

    /* Two layers, the new image fading over the old. The original layer keeps
       its view-transition attributes for the card-to-page morph. */
    var layerB = baseImage.cloneNode(false);
    layerB.removeAttribute('data-view-transition-type');
    layerB.removeAttribute('data-bq-gallery-image');
    layerB.setAttribute('aria-hidden', 'true');
    layerB.classList.add('bq-gallery__img--layer');
    layerB.dataset.hidden = '';
    baseImage.classList.add('bq-gallery__img--layer');
    baseImage.after(layerB);
    var current = baseImage;
    var standby = layerB;
    var currentIndex = 0;

    var count = null;
    if (thumbs.length > 1) {
      count = document.createElement('span');
      count.className = 'bq-gallery__count';
      count.setAttribute('aria-hidden', 'true');
      stage.appendChild(count);
    }

    function renderCount() {
      if (count) count.textContent = (currentIndex + 1) + ' / ' + thumbs.length;
    }
    renderCount();

    function swapTo(thumb, index) {
      if (!thumb || thumb.classList.contains('is-sel')) return;
      currentIndex = index;
      var incoming = standby;
      var outgoing = current;

      var apply = function () {
        if (thumb.dataset.srcset) incoming.srcset = thumb.dataset.srcset;
        incoming.src = thumb.dataset.full || '';
        incoming.alt = thumb.dataset.alt || '';
        var reveal = function () {
          delete incoming.dataset.hidden;
          outgoing.dataset.hidden = '';
          outgoing.style.transform = '';
          current = incoming;
          standby = outgoing;
        };
        var revealed = false;
        var revealOnce = function () {
          if (revealed) return;
          revealed = true;
          reveal();
        };
        if (incoming.decode) {
          incoming.decode().then(revealOnce, revealOnce);
        } else if (incoming.complete) {
          revealOnce();
        } else {
          incoming.onload = revealOnce;
        }
        // decode() can lag in a background tab or on a slow network: swap at 500ms
        // regardless, trading a possible flash for never stalling.
        setTimeout(revealOnce, 500);
      };
      apply();

      thumbs.forEach(function (t) { t.classList.remove('is-sel'); });
      thumb.classList.add('is-sel');
      renderCount();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { swapTo(thumb, i); });
    });

    function step(dir) {
      if (thumbs.length < 2) return;
      var n = ((currentIndex + dir) % thumbs.length + thumbs.length) % thumbs.length;
      swapTo(thumbs[n], n);
    }

    gallery.querySelectorAll('[data-bq-gallery-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        step(btn.getAttribute('data-bq-gallery-nav') === 'next' ? 1 : -1);
      });
    });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
    });

    var touchX = null;
    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') touchX = event.clientX;
    }, { passive: true });
    stage.addEventListener('pointerup', function (event) {
      if (event.pointerType !== 'touch' || touchX === null) return;
      var dx = event.clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    var preloaded = false;
    function preloadAll() {
      if (preloaded) return;
      preloaded = true;
      thumbs.forEach(function (t) {
        if (!t.dataset.full) return;
        var im = new Image();
        if (t.dataset.srcset) im.srcset = t.dataset.srcset;
        im.src = t.dataset.full;
      });
    }
    gallery.addEventListener('pointerenter', preloadAll, { once: true });
    gallery.addEventListener('touchstart', preloadAll, { once: true, passive: true });
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadAll, { timeout: 4000 });
    } else {
      setTimeout(preloadAll, 3000);
    }

    // Inside the quick-add dialog the full-screen viewer would paint under the top
    // layer and the magnifier has no room, so both are skipped.
    if (gallery.closest('dialog')) return;

    if (!canHover) {
      // Mobile and tablet: a tap opens a full-screen viewer, one snap slide per
      // media, dismissed by a tap anywhere, the X or Escape.
      var smooth = matchMedia('(prefers-reduced-motion: no-preference)').matches;
      var shots = thumbs.length
        ? thumbs.map(function (t) {
            return { src: t.dataset.full || '', srcset: t.dataset.srcset || '', alt: t.dataset.alt || '' };
          })
        : [{ src: baseImage.currentSrc || baseImage.src, srcset: '', alt: baseImage.alt || '' }];

      var box = null;
      var track = null;
      var counter = null;
      var opener = null;
      var scrollFrame = 0;
      var downX = 0;
      var downY = 0;
      var tapX = 0;
      var tapY = 0;

      // Left to the browser, a pinch scales the visual viewport and panning then
      // scrolls the snap track to the next photo mid-inspection.
      var MAX_SCALE = 4;
      var pointers = new Map();
      var zoom = { scale: 1, x: 0, y: 0 };
      var pinch = null;
      var panFrom = null;
      var lastTap = 0;

      function viewerIndex() {
        return Math.round(track.scrollLeft / (track.clientWidth || 1));
      }

      function zoomedImage() {
        var slide = track && track.children[viewerIndex()];
        return slide ? slide.querySelector('img') : null;
      }

      // Keeps the magnified photo covering the frame; past its edges the visitor
      // drags a black void and loses the product.
      function clampPan(img) {
        if (!img) return;
        var overX = Math.max(0, (img.clientWidth * zoom.scale - img.clientWidth) / 2);
        var overY = Math.max(0, (img.clientHeight * zoom.scale - img.clientHeight) / 2);
        zoom.x = Math.min(overX, Math.max(-overX, zoom.x));
        zoom.y = Math.min(overY, Math.max(-overY, zoom.y));
      }

      function paintZoom(img) {
        var target = img || zoomedImage();
        if (!target) return;
        clampPan(target);
        target.style.transform =
          'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.scale + ')';
        // Only ever adds: the track stays frozen while two fingers are down, even
        // as the pinch passes back through scale 1. resetZoom releases it.
        if (zoom.scale > 1.01) box.classList.add('is-zoomed');
      }

      // Direct manipulation is 1:1 and never eased; the double tap is a command,
      // so it gets the viewer's only transition.
      function easeOnce(img) {
        if (!img || !smooth) return;
        img.style.transition = 'transform 0.28s var(--bq-ease, ease)';
        img.addEventListener('transitionend', function clear() {
          img.style.transition = '';
          img.removeEventListener('transitionend', clear);
        });
      }

      function resetZoom() {
        var img = zoomedImage();
        zoom.scale = 1;
        zoom.x = 0;
        zoom.y = 0;
        pinch = null;
        panFrom = null;
        pointers.clear();
        if (img) img.style.transform = '';
        if (box) box.classList.remove('is-zoomed');
      }

      function goTo(index, animate) {
        var last = shots.length - 1;
        var i = index < 0 ? 0 : index > last ? last : index;
        resetZoom();
        track.scrollTo({ left: i * (track.clientWidth || 1), behavior: animate && smooth ? 'smooth' : 'auto' });
      }

      function renderViewerCount() {
        if (counter) counter.textContent = viewerIndex() + 1 + ' / ' + shots.length;
      }

      // Chevron path data is ours, the alt text is not: anything from the
      // product goes through textContent or alt, never innerHTML.
      function viewerButton(className, label, path) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = className;
        if (label) button.setAttribute('aria-label', label);
        button.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
        return button;
      }

      function buildViewer() {
        box = document.createElement('div');
        box.className = 'bq-gallery__lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');

        track = document.createElement('div');
        track.className = 'bq-gallery__lightbox-track';
        shots.forEach(function (shot) {
          var slide = document.createElement('div');
          slide.className = 'bq-gallery__lightbox-slide';
          var img = document.createElement('img');
          img.decoding = 'async';
          img.sizes = '100vw';
          if (shot.srcset) img.srcset = shot.srcset;
          img.src = shot.src;
          img.alt = shot.alt;
          slide.appendChild(img);
          track.appendChild(slide);
        });
        box.appendChild(track);

        var closeButton = viewerButton(
          'bq-gallery__lightbox-close',
          gallery.dataset.labelClose,
          'M6 6l12 12M18 6L6 18'
        );
        closeButton.dataset.close = '';
        box.appendChild(closeButton);

        if (shots.length > 1) {
          var prev = viewerButton(
            'bq-gallery__lightbox-nav bq-gallery__lightbox-nav--prev',
            gallery.dataset.labelPrev,
            'M15 5 8 12l7 7'
          );
          prev.dataset.step = '-1';
          var next = viewerButton(
            'bq-gallery__lightbox-nav bq-gallery__lightbox-nav--next',
            gallery.dataset.labelNext,
            'M9 5l7 7-7 7'
          );
          next.dataset.step = '1';
          counter = document.createElement('span');
          counter.className = 'bq-gallery__lightbox-count';
          counter.setAttribute('aria-hidden', 'true');
          box.appendChild(prev);
          box.appendChild(next);
          box.appendChild(counter);

          track.addEventListener('scroll', function () {
            if (scrollFrame) return;
            scrollFrame = requestAnimationFrame(function () {
              scrollFrame = 0;
              renderViewerCount();
            });
          }, { passive: true });
        }

        box.addEventListener('pointerdown', function (event) {
          tapX = event.clientX;
          tapY = event.clientY;
        });
        box.addEventListener('click', function (event) {
          var stepper = event.target.closest('[data-step]');
          if (stepper) {
            goTo(viewerIndex() + Number(stepper.dataset.step), true);
            return;
          }
          if (event.target.closest('[data-close]')) {
            closeViewer();
            return;
          }
          // A stray tap must not dismiss the viewer while a photo is magnified; the
          // close button stays available.
          if (zoom.scale > 1.01) return;
          // A snap swipe ends in a click, so only a genuine tap closes.
          if (Math.abs(event.clientX - tapX) > 10 || Math.abs(event.clientY - tapY) > 10) return;
          closeViewer();
        });

        function spread() {
          var pts = Array.from(pointers.values());
          var dx = pts[0].x - pts[1].x;
          var dy = pts[0].y - pts[1].y;
          return {
            dist: Math.hypot(dx, dy) || 1,
            cx: (pts[0].x + pts[1].x) / 2,
            cy: (pts[0].y + pts[1].y) / 2,
          };
        }

        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'touch') return;
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          if (pointers.size === 2) {
            // Freeze on the second finger, before the browser reads the pair as a
            // horizontal pan and slides the track out from under the pinch.
            var i = viewerIndex();
            box.classList.add('is-zoomed');
            track.scrollLeft = i * (track.clientWidth || 1);
            var s = spread();
            pinch = { dist: s.dist, cx: s.cx, cy: s.cy, scale: zoom.scale, x: zoom.x, y: zoom.y };
            panFrom = null;
          } else if (pointers.size === 1 && zoom.scale > 1.01) {
            panFrom = { x: event.clientX, y: event.clientY, ox: zoom.x, oy: zoom.y };
          }
        }, { passive: true });

        // Non-passive: a magnified photo owns its gesture, so the move must be
        // preventable or the browser scrolls the track under the finger.
        track.addEventListener('pointermove', function (event) {
          if (event.pointerType !== 'touch' || !pointers.has(event.pointerId)) return;
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

          if (pointers.size >= 2 && pinch) {
            event.preventDefault();
            var s = spread();
            zoom.scale = Math.min(MAX_SCALE, Math.max(1, pinch.scale * (s.dist / pinch.dist)));
            // Follow the fingers: the point pinched stays under them.
            zoom.x = pinch.x + (s.cx - pinch.cx);
            zoom.y = pinch.y + (s.cy - pinch.cy);
            paintZoom();
            return;
          }

          if (pointers.size === 1 && panFrom && zoom.scale > 1.01) {
            event.preventDefault();
            zoom.x = panFrom.ox + (event.clientX - panFrom.x);
            zoom.y = panFrom.oy + (event.clientY - panFrom.y);
            paintZoom();
          }
        }, { passive: false });

        function releasePointer(event) {
          if (event.pointerType !== 'touch') return;
          pointers.delete(event.pointerId);
          if (pointers.size < 2) pinch = null;
          if (pointers.size === 0) {
            panFrom = null;
            // Snap back rather than leave the photo at 1.004, or the track is
            // never released and the next swipe silently does nothing.
            if (zoom.scale <= 1.01) resetZoom();
          }
        }
        track.addEventListener('pointerup', releasePointer, { passive: true });
        track.addEventListener('pointercancel', releasePointer, { passive: true });

        // Double tap, the gesture tried before pinching.
        track.addEventListener('pointerup', function (event) {
          if (event.pointerType !== 'touch') return;
          var now = event.timeStamp;
          if (now - lastTap < 300) {
            lastTap = 0;
            var img = zoomedImage();
            if (!img) return;
            easeOnce(img);
            if (zoom.scale > 1.01) {
              zoom.scale = 1;
              zoom.x = 0;
              zoom.y = 0;
              img.style.transform = '';
              box.classList.remove('is-zoomed');
            } else {
              var r = img.getBoundingClientRect();
              zoom.scale = 2.5;
              // Magnify around the tapped point, not the centre.
              zoom.x = (r.left + r.width / 2 - event.clientX) * (zoom.scale - 1);
              zoom.y = (r.top + r.height / 2 - event.clientY) * (zoom.scale - 1);
              paintZoom(img);
            }
          } else {
            lastTap = now;
          }
        }, { passive: true });

        // Safari honours touch-action but still emits its own gesture events,
        // which unhandled would zoom the page behind the viewer.
        ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
          box.addEventListener(type, function (e) { e.preventDefault(); });
        });

        document.body.appendChild(box);
      }

      function openViewer() {
        if (!shots[0] || !shots[0].src) return;
        if (!box) buildViewer();
        opener = document.activeElement;
        box.classList.add('is-open');
        document.documentElement.classList.add('bq-lightbox-lock');
        // The track needs a layout before it can be scrolled to a slide.
        requestAnimationFrame(function () {
          goTo(currentIndex, false);
          renderViewerCount();
          box.querySelector('[data-close]').focus();
        });
      }

      function closeViewer() {
        if (!box) return;
        resetZoom();
        box.classList.remove('is-open');
        document.documentElement.classList.remove('bq-lightbox-lock');
        if (opener && opener.focus) opener.focus();
        opener = null;
      }

      stage.addEventListener('pointerdown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
      });
      stage.addEventListener('click', function (event) {
        if (event.target.closest('[data-bq-gallery-nav]')) return;
        // A swipe, handled above, ends in a click: only open on a genuine tap.
        if (Math.abs(event.clientX - downX) > 10 || Math.abs(event.clientY - downY) > 10) return;
        openViewer();
      });
      // Bound outside the gallery, so a section re-render leaves this listener
      // behind; it drops itself the first time the gallery is gone.
      addEventListener('keydown', function onEsc(e) {
        if (!gallery.isConnected) { removeEventListener('keydown', onEsc); return; }
        if (e.key === 'Escape') closeViewer();
      });
      return;
    }

    function setOrigin(event) {
      var rect = stage.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
      var y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
      current.style.transformOrigin = x + '% ' + y + '%';
    }

    // Zoom is driven by mousemove, so a chevron click leaves the new photo
    // flat until the pointer moves.
    stage.addEventListener('mousemove', function (event) {
      setOrigin(event);
      current.style.transform = 'scale(' + ZOOM + ')';
    });
    stage.addEventListener('mouseleave', function () {
      // Zoom out without touching transform-origin, which would jump.
      current.style.transform = '';
    });
  }

  function scan(scope) {
    scope.querySelectorAll('[data-bq-gallery]').forEach(initGallery);
  }

  if (document.readyState !== 'loading') {
    scan(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
